import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import type { U3121ProjectEmployeeAssignmentHandlerReturn } from "./U3121ProjectEmployeeAssignmentHandlers";
import type { U3121EmployeeBillingAssignment } from "../../../../U3121Service";

function getAssignmentLabel(row: U3121EmployeeBillingAssignment): string {
  const emp = row.employee;
  const name = emp ? [emp.firstName, emp.lastName].filter(Boolean).join(" ") : "";
  const code = emp?.codeEmployee ? ` (${emp.codeEmployee})` : "";
  const task = row.task?.taskCode ?? row.task?.taskDescription ?? "";
  const parts = [name + code, task].filter(Boolean);
  return parts.length ? parts.join(" – ") : row.id;
}

interface U3121ProjectEmployeeAssignmentDeleteDlgProps {
  handler: U3121ProjectEmployeeAssignmentHandlerReturn;
  t: TFunction;
  NS: string;
}

function U3121ProjectEmployeeAssignmentDeleteDlg({ handler, t, NS }: U3121ProjectEmployeeAssignmentDeleteDlgProps) {
  if (!handler.isDeleteDialogOpen) return null;

  return (
    <U2000DeleteRecordDialog
      isOpen={handler.isDeleteDialogOpen}
      onClose={handler.onDlgDeleteClose}
      title={t("lblEmployeeBillingAssignment", { ns: NS })}
    >
      <p className="mb-4">{t("msgDeleteEmployeeAssignment", { ns: NS })}</p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {handler.gridStateHandlers.getSelectedRows().map((row: U3121EmployeeBillingAssignment, index: number, array: U3121EmployeeBillingAssignment[]) => (
          <span key={row.id} className="inline-block text-gray-800">
            {getAssignmentLabel(row)}
            {index < array.length - 1 && ", "}
          </span>
        ))}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U3121ProjectEmployeeAssignmentDeleteDlg;
